import React from "react";

function About(){
    return(
        <>
       <div className="container mb-5 mt-5">
        <div className="row mb-5">
          <div className="about_title">
            <p className="fw-bold">ABOUT US</p>
            <h3 className="fw-bold bg_text">What We Do</h3>
            <div class="fancy-border"></div>
          </div>
        </div>

        <div className="row">
            <div className="col-lg-4">
           <div className="mb-3">
           <img className="" src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/3.png" class="img-fluid" />
           </div>
            <h3 className="fw-bold bg_text fs-5">Conventional Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">Conventional fruit shop: affordable fruits grown with pesticides for accessibility, but with concerns about chemical residues.</p
            >
            </div>
             <div className="col-lg-4">
             <div className="mb-3">
             <img  src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/2.png" class="img-fluid" />
             </div>
            <h3 className="fw-bold bg_text fs-5">Organic Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">An organic fruit shop offers eco-friendly fruits grown without synthetic pesticides or fertilizers, though it's often pricier.</p
            >
            </div>
            <div className="col-lg-4">
                <div  className="mb-4">
                <img src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/1.png" class="img-fluid" />
                </div>
             
            <h3 className="fw-bold bg_text fs-5">Our Fresh Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">Growing your own fruits at home brings cost savings, reduces waste, and offers the joy of enjoying fresh sustainable hobby.</p
            >
            </div>          
        </div>
       </div>
        </>
    );
}

export default About;